export default {
      id: "communication-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#communication",
      toString: function () {
        return this.url;
      }
    }